export const ROLES = {
  USER: "user",
  OFFICER: "officer",
  ADMIN: "Admin",
  SUPER_ADMIN: "super admin",
  ACTING_SA: "acting_sa",
  FINANCE: "finance",
  SAP: "sap",
  SUPPORT: "support",

  // PONPURE DOA Roles
  REQUESTOR: "requestor",
  PROCUREMENT_BUYER: "procurement_buyer",
  TAX_REVIEWER: "tax_reviewer",
  FINANCE_REVIEWER: "finance_reviewer",
  MASTER_DATA_TEAM: "master_data_team",
  CFO: "cfo",
  FINANCE_REVIEWER_INTL: "finance_reviewer_intl",
};

export const ADMIN_ROLES = [
  ROLES.SUPER_ADMIN,
  ROLES.ADMIN,
  ROLES.FINANCE,
  ROLES.ACTING_SA,
  ROLES.TAX_REVIEWER,
  ROLES.FINANCE_REVIEWER,
  ROLES.MASTER_DATA_TEAM,
  ROLES.CFO,
  ROLES.FINANCE_REVIEWER_INTL,
];
